export enum MessageType {
  OPEN = 0,
  OPEN_ACK = 12,

  PING = 8,
  PONG = 9,

  JOIN = 1,
  JOIN_ACK = 3,
  JOIN_ERROR = 4,

  LEAVE = 2,
  LEAVE_ACK = 5,
  LEAVE_ERROR = 6,

  EVENT = 7,
  EVENT_ERROR = 10,
  EVENT_COMPLETE = 11
}
